import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

(function () {
  const swiperSliders = document.querySelectorAll(".reference-slider");

  let newsSwiper = [];

  for (let i = 0; i < swiperSliders.length; i++) {
    // const navigationWrapper = swiperSliders[i]
    //   .closest(".com-image-slider")
    //   .querySelector(".swiper-navigation");
    // const nextEl = navigationWrapper.querySelector(".swiper-button-next");
    // const prevEl = navigationWrapper.querySelector(".swiper-button-prev");

    newsSwiper[i] = new Swiper(swiperSliders[i], {
      modules: [Navigation, Pagination],
      loop: false,
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        600: {
            slidesPerView: 2,
            spaceBetween: 15,
        },
        900: {
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1200: {
            slidesPerView: 4,
            spaceBetween: 15,
        },
      },
    });
  }

  const loadMoreReferencesBtn = document.getElementById('load-more-references');
  if (!loadMoreReferencesBtn) return;

  loadMoreReferencesBtn.addEventListener('click', function() {
      let currentPage = parseInt(loadMoreReferencesBtn.dataset.page, 10);
      const maxPages = parseInt(loadMoreReferencesBtn.dataset.max, 10);
      const query = JSON.parse(loadMoreReferencesBtn.dataset.query);

      if (currentPage >= maxPages) return;

      loadMoreReferencesBtn.textContent = "Lädt ...";

      const formData = new FormData();
      formData.append('action', 'kb_load_more_references');
      formData.append('query', JSON.stringify(query));
      formData.append('page', currentPage);

      jQuery.ajax({
          url: globalvars.ajaxurl,
          type: 'POST',
          data: {
              action: 'kb_load_more_references',
              nonce: globalvars.ajax_nonce,
              query: JSON.stringify(query),
              page: currentPage
          },
          success: function(data) {
              document.getElementById('archives-wrapper').insertAdjacentHTML('beforeend', data);
              currentPage++;
              loadMoreReferencesBtn.dataset.page = currentPage;
              if (currentPage >= maxPages) {
                loadMoreReferencesBtn.style.display = 'none';
              } else {
                loadMoreReferencesBtn.textContent = "Weitere Referenzen";
              }
          },
          error: function() {
              loadMoreReferencesBtn.textContent = "Fehler!";
          }
      });
  });
})();
